// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountServiceModel {
    static getAttributeTypeMap() {
        return AccountServiceModel.attributeTypeMap;
    }
}
AccountServiceModel.discriminator = undefined;
AccountServiceModel.attributeTypeMap = [
    {
        "name": "serviceTypeCode",
        "baseName": "serviceTypeCode",
        "type": "string"
    }
];
//# sourceMappingURL=accountServiceModel.js.map